export const CraneColors = ['primary', 'info', 'warning', 'busy', 'error']
